import React, { useEffect } from "react";
import { Amplify } from "aws-amplify";
import awsmobile from "./aws-exports";
import AudioRecorder from "./AudioRecorder";
import { Authenticator, View, Text, Button, Heading, Image } from "@aws-amplify/ui-react";
import '@aws-amplify/ui-react/styles.css';
import './App.css';  // Ensure this is scoped appropriately
import logo from "./assets/images/Amoofy_Logo.png";

// Configure Amplify
Amplify.configure(awsmobile);

// VideoAsk-inspired custom theme
const theme = {
  name: 'videoask-inspired-theme',
  tokens: {
    colors: {
      brand: {
        primary: {
          10: '#6366F1',
          80: '#4F46E5',
          90: '#4338CA',
          100: '#3730A3',
        },
        secondary: '#F9FAFB',
      },
      background: {
        primary: '#F9FAFB',
        secondary: '#FFFFFF',
      },
      font: {
        interactive: '#FFFFFF',
      },
      border: {
        primary: '#E5E7EB',
        secondary: '#D1D5DB',
      },
    },
    fonts: {
      default: {
        variable: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        static: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      },
    },
    components: {
      authenticator: {
        router: {
          borderRadius: '8px',
          boxShadow: '0px 4px 25px rgba(0, 0, 0, 0.05)',
          width: '400px',
          maxWidth: '100%',
        },
        container: {
          padding: '2rem',
        },
        form: {
          padding: '0.5rem 0',
        },
      },
      button: {
        primary: {
          backgroundColor: '#4F46E5',
          borderRadius: '6px',
          fontSize: '0.875rem',
          fontWeight: '500',
          height: '42px',
          paddingInlineStart: '1rem',
          paddingInlineEnd: '1rem',
          borderColor: '#4F46E5',
          _hover: {
            backgroundColor: '#4338CA',
            borderColor: '#4338CA',
          },
          _focus: {
            backgroundColor: '#3730A3',
            borderColor: '#3730A3',
          },
          _active: {
            backgroundColor: '#6366F1',
            borderColor: '#6366F1',
          },
        },
      },
      input: {
        color: '#1F2937',
        borderColor: '#E5E7EB',
        borderRadius: '6px',
        fontSize: '0.875rem',
        height: '42px',
        _focus: {
          borderColor: '#4F46E5',
        },
      },
      heading: {
        color: '#111827',
        fontWeight: '600',
      },
      text: {
        color: '#6B7280',
      },
    },
  },
};

const components = {
  Header() {
    return (
      <>
        <div style={{ position: 'absolute', top: '1rem', left: '1rem' }}>
          <Image src={logo} alt="Amoofy Logo" height="50px" objectFit="contain" />
        </div>
        <View textAlign="center" padding="2rem 0 1rem">
          <Heading level={2} padding="0 1rem 0.5rem" color="white">
            Amoofy Capture App
          </Heading>
          <Text variation="secondary" lineHeight="1.5" fontWeight="400" padding="0 1.5rem" color="#F9FAFB">
            Please log in to capture your story...
          </Text>
        </View>
      </>
    );
  },
  Footer() {
    return (
      <View textAlign="center" padding="1rem 0">
        <Text fontSize="0.8rem" color="#6B7280">
          &copy; {new Date().getFullYear()} Amoofy. All rights reserved.
        </Text>
      </View>
    );
  },
  SignIn: {
    Header() {
      return null;
    },
  },
};

const formFields = {
  signIn: {
    username: {
      placeholder: 'Email or username',
      label: 'Email or username',
    },
    password: {
      placeholder: 'Password',
      label: 'Password',
    },
  },
  signUp: {
    username: {
      placeholder: 'Email',
      label: 'Email',
    },
    password: {
      placeholder: 'Create a password',
      label: 'Password',
    },
    confirm_password: {
      placeholder: 'Confirm your password',
      label: 'Confirm password',
    },
  },
};

function App() {
  useEffect(() => {
    document.body.style.backgroundColor = '#F9FAFB';
    
    return () => {
      document.body.style.backgroundColor = '';
    };
  }, []);

  return (
    <div className="App">
  <Authenticator theme={theme} components={components} formFields={formFields} variation="modal">
    {({ signOut, user }) => (
      <div className="App-content">
        <div style={{
          position: 'absolute',
          top: '20px',
          right: '20px'
        }}>
          <Button
            onClick={signOut}
            variation="primary"
            size="large"
            backgroundColor="transparent"
            _hover={{ backgroundColor: "#DAA520" }}
          >
            Sign Out
          </Button>
        </div>
         <header className="App-header" style={{ paddingTop: '50px', margin: '0 auto', textAlign: 'left' }}>
        <h1 style={{ color: 'Yellow', fontSize: '1.5rem', marginBottom: '5px', textAlign: 'center', fontWeight: '600'}}><strong>Please share your story with us...</strong></h1>  
        <div style={{ 
          background: 'white', 
          padding: '2px', 
          borderRadius: '10px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)', 
          marginBottom: '20px'
        }}> 
          <p style={{ 
            color: '#4F46E5', 
            fontSize: '1rem',
            fontWeight: '600',
            marginBottom: '8px'
        }}>Question 1:</p>
        <p style={{ 
          color: '#4F46E5', 
          fontSize: '0.95rem',
          fontWeight: '600',
          lineHeight: '1.5',
          marginBottom: '15px'
    }}>What role did education play in transforming your career trajectory, and how did you manage to balance it with your professional life?</p>
  </div>
  <div style={{
    background: 'white',
    padding: '2px',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    marginBottom: '20px'
  }}>
    <p style={{ 
      color: '#4F46E5', 
      fontSize: '1rem',
      fontWeight: '600',
      marginBottom: '8px'
    }}>Question 2</p>
    <p style={{ 
      color: '#4F46E5', 
      fontSize: '0.95rem',
      fontWeight: '600',
      lineHeight: '1.5',
      marginBottom: '15px'
    }}>How did your career journey evolve, especially after facing numerous rejections?</p>
  </div> 
  <div style={{
    background: 'white',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    marginBottom: '20px'
  }}>
    <p style={{ 
      color: '#4F46E5', 
      fontSize: '1rem',
      fontWeight: '600',
      marginBottom: '8px'
    }}>Question 3</p>
    <p style={{ 
      color: '#4F46E5', 
      fontSize: '0.95rem',
      fontWeight: '600',
      lineHeight: '1.5',
      marginBottom: '15px'
    }}>With your new degree, what new opportunities are you excited to explore in your career?</p>
  </div>

          {/* p style={{ color: 'white', fontSize: '0.9rem' }}><strong>3.- With your new degree, what new opportunities are you excited to explore in your career?</strong></p> */}
          {/* <h1>Amoofy Capture App</h1> */}
          {/* <p>Record and upload your audio!</p> */}
 
          <AudioRecorder />
        </header>
      </div>
    )}
  </Authenticator>
</div>
);
}

export default App;